export class TakeOffItem {
  GUID: string;
  development: object;
  file: { id: string };
  ifcLabel: string;
  // TODO - Obter a interface correta desse item
  materials: object;
  modelMapId: string;
  name: string;
  parentGUID: string;
  // TODO - Obter a interface correta desse item; verificar dados em outros modelos
  properties: object;
  type: string;
  wbsId: string;

  constructor(
    GUID: string,
    development: object,
    file: { id: string },
    ifcLabel: string,
    materials: object,
    modelMapId: string,
    name: string,
    parentGUID: string,
    properties: object,
    type: string,
    wbsId: string
  ) {
    this.GUID = GUID;
    this.development = development;
    this.file = file;
    this.ifcLabel = ifcLabel;
    this.materials = materials;
    this.modelMapId = modelMapId;
    this.name = name;
    this.parentGUID = parentGUID;
    this.properties = properties;
    this.type = type;
    this.wbsId = wbsId;
  }
}



// WEBPACK FOOTER //
// ./src/modules/takeOff/models/TakeOffItem.ts